import { render } from "./EditDropdown.vue?vue&type=template&id=62c77fe8&scoped=true"
import script from "./EditDropdown.vue?vue&type=script&lang=js"
export * from "./EditDropdown.vue?vue&type=script&lang=js"

import "./EditDropdown.vue?vue&type=style&index=0&id=62c77fe8&lang=css&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c77fe8"]])

export default __exports__